var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("button", {
      ref: "addressSuggestion",
      staticClass: "btn btn-primary d-none",
      attrs: {
        type: "button",
        "data-toggle": "modal",
        "data-target": "#addressSuggestionModal"
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "addressSuggestionModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "ModalLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-lg",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "exampleModalLabel" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString[
                            "checkout.AddressVerification.Modal.Title"
                          ]
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    ref: "closeAddressSuggestion",
                    staticClass: "wf-modal-button-close btn button-full",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-symbols--k-txtclose",
                      attrs: { "aria-label": "Close modal" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", {
                  staticClass:
                    "small mb-4 align-top text-muted font-weight-light mark p-2",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$resourceString[
                        "checkout.AddressVerification.Modal.SubTitle"
                      ]
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-group small fw-light" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "custom-control custom-radio small bg-light p-4 mb-3"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.checkBoxAddress,
                            expression: "checkBoxAddress"
                          }
                        ],
                        staticClass: "custom-control-input",
                        attrs: {
                          type: "radio",
                          id: "customRadio1",
                          name: "customRadio",
                          value: "currentAddress"
                        },
                        domProps: {
                          checked: _vm._q(_vm.checkBoxAddress, "currentAddress")
                        },
                        on: {
                          change: function($event) {
                            _vm.checkBoxAddress = "currentAddress"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "custom-control-label text-uppercase",
                          attrs: { for: "customRadio1" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$resourceString[
                                  "checkout.AddressVerification.Modal.EnteredAddress.Label"
                                ]
                              ) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.checkoutData.FirstName) +
                            " " +
                            _vm._s(_vm.checkoutData.LastName) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.checkoutData.AddressLine1))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.checkoutData.City) +
                            " " +
                            _vm._s(_vm.checkoutData.State) +
                            "\n                " +
                            _vm._s(_vm.checkoutData.PostalCode) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.checkoutData.Country))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.checkoutData.ChangedAddress
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "custom-control custom-radio small bg-light p-4 mb-3"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkBoxAddress,
                                expression: "checkBoxAddress"
                              }
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              type: "radio",
                              id: "customRadio2",
                              name: "customRadio",
                              value: "suggestedAddress"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.checkBoxAddress,
                                "suggestedAddress"
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.checkBoxAddress = "suggestedAddress"
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "custom-control-label text-uppercase",
                              attrs: { for: "customRadio2" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "checkout.AddressVerification.Modal.ChangedAddress.Label"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-1" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.checkoutData.FirstName) +
                                " " +
                                _vm._s(_vm.checkoutData.LastName) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mb-1",
                              class:
                                _vm.checkoutData.AddressLine1 !=
                                _vm.checkoutData.ChangedAddress.AddressLine1
                                  ? "changed-address"
                                  : ""
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.checkoutData.ChangedAddress.AddressLine1
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-1" }, [
                            _c(
                              "span",
                              {
                                class:
                                  _vm.checkoutData.City !=
                                  _vm.checkoutData.ChangedAddress.Locality
                                    ? "changed-address"
                                    : ""
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.checkoutData.ChangedAddress.Locality
                                    ) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.checkoutData.State !=
                                  _vm.checkoutData.ChangedAddress
                                    .AdministrativeArea
                                    ? "changed-address"
                                    : ""
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.checkoutData.ChangedAddress
                                        .AdministrativeArea
                                    ) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.checkoutData.PostalCode !=
                                  _vm.checkoutData.ChangedAddress.PostalCode
                                    ? "changed-address"
                                    : ""
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.checkoutData.ChangedAddress.PostalCode
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-0" }, [
                            _c(
                              "span",
                              {
                                class:
                                  _vm.checkoutData.Country !=
                                  _vm.checkoutData.ChangedAddress.Country
                                    ? "changed-address"
                                    : ""
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.checkoutData.ChangedAddress.Country
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer d-flex justify-content-around" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.submitFormFromModel(true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "checkout.AddressVerification.Modal.ContinueButton"
                            ]
                          ) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.submitFormFromModel(false)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "checkout.AddressVerification.Modal.EditButton"
                            ]
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ]
              )
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("button", {
      ref: "addressMelissa",
      staticClass: "btn btn-primary d-none",
      attrs: {
        type: "button",
        "data-toggle": "modal",
        "data-target": "#addressMelissaModal"
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "addressMelissaModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "ModalLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-lg",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "addressMelissaModalLabel" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString[
                            "checkout.AddressVerification.Modal.Title"
                          ]
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    ref: "closeAddressMelica",
                    staticClass: "wf-modal-button-close btn button-full",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-symbols--k-txtclose",
                      attrs: { "aria-label": "Close modal" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "small mb-4 align-top text-muted font-weight-light mark p-2"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString[
                            "checkout.AddressVerification.InvalidMelica.Modal.SubTitle"
                          ]
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group small fw-light" }, [
                  _vm.checkoutData.IsAddressNotPresizeOnMelissa &&
                  _vm.checkoutData.ChangedAddress == null
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "custom-control custom-radio small bg-light p-4 mb-3"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkBoxAddress,
                                expression: "checkBoxAddress"
                              }
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              type: "radio",
                              id: "customRadio3",
                              name: "customRadio",
                              value: "currentAddress"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.checkBoxAddress,
                                "currentAddress"
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.checkBoxAddress = "currentAddress"
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "custom-control-label text-uppercase",
                              attrs: { for: "customRadio3" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "checkout.AddressVerification.Modal.EnteredAddress.Label"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-0" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.checkoutData.FirstName) +
                                " " +
                                _vm._s(_vm.checkoutData.LastName) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-0" }, [
                            _vm._v(_vm._s(_vm.checkoutData.AddressLine1))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-0" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.checkoutData.City) +
                                " " +
                                _vm._s(_vm.checkoutData.State) +
                                "\n                " +
                                _vm._s(_vm.checkoutData.PostalCode) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-0" }, [
                            _vm._v(_vm._s(_vm.checkoutData.Country))
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer d-flex justify-content-around" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.submitFormFromModel(true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "checkout.AddressVerification.Modal.ContinueButton"
                            ]
                          ) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.submitFormFromModel(false)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "checkout.AddressVerification.Modal.EditButton"
                            ]
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }